<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm' size='mini' label-position='left'  label-suffix=":")
            div(class="mb-game-userInfo")
                el-form-item(label='姓名' )
                    <span>{{mbForm.name}}</span>
                el-form-item(label='账号' )
                    <span>{{mbForm.mobile}}</span>
                el-form-item(label='身份证件')
                    <span>{{mbForm.idCard}}</span>
                el-form-item(label='性别' )
                    <span>{{mbForm.gender}}</span>
                el-form-item(label='总场次')
                    <span>{{mbForm.gameNum}}</span>
                el-form-item(label='总积分')
                    <span>{{mbForm.scoreNum}}</span>
                el-form-item(label='年度积分')
                    <span>{{mbForm.yearScore}}</span>
                el-form-item(label='季度积分')
                    <span>{{mbForm.quarterScore}}</span>
            el-row(:span='24' )
              el-col(:md='5' :sm="8")
                el-form-item(label='比赛类型')
                    el-select(v-model='dataForm.ctType',placeholder='请选择',style='width:160px;',clearable)
                        el-option(label='常规赛',value="1")
                        el-option(label='月度赛',value="2")
                        el-option(label='季度赛',value="3")
                        el-option(label='年度总决赛',value="4")
                        el-option(label='挑战赛',value="5")
                        el-option(label='群英赛',value="6")
              el-col(:md='5' :sm="8")
                el-form-item(label='比赛项目')
                    el-select(v-model='dataForm.projectType',placeholder='请选择',style='width:160px;',clearable)
                        el-option(label='单打',value="1")
                        el-option(label='双打',value="2")
              el-col(:md='5' :sm="8")
                el-form-item(label='比赛级别')
                    el-select(v-model='dataForm.level',placeholder='请选择',style='width:160px;',clearable)
                        el-option(label="2.0" value="2.0")
                        el-option(label="2.5" value="2.5")
                        el-option(label="3.0" value="3.0")
                        el-option(label="3.5" value="3.5")
                        el-option(label="4.0" value="4.0")
                        el-option(label="4.5" value="4.5")
                        el-option(label="5.0" value="5.0")
              el-col(:md='9' :sm="24")
                el-form-item(label='比赛时间')
                        el-date-picker(v-model="dataForm.ctStrTime"  type="datetime" placeholder="选择日期时间" style='width:173px')
                        font() &nbsp;至&nbsp;
                         el-date-picker(v-model="dataForm.ctEndTime"  type="datetime" placeholder="选择日期时间" style='width:173px')
            el-row
                el-col(:span="24" style="padding-bottom:15px;")
                        el-button(@click='getDataList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" ,  v-loading='dataListLoading' border)
            el-table-column(prop='matchId',header-align='center',align='center',label='比赛ID')
            el-table-column(prop='matchName',header-align='center',align='center',label='比赛名称')
            el-table-column(prop='matchStartTime',header-align='center',align='center',label='比赛时间')
            el-table-column(prop='venueAddress',header-align='center',align='center',label='比赛地点')
            el-table-column(prop='ctType',header-align='center',align='center',label='比赛类型')
               template(slot-scope='scope')
                   font(v-if='scope.row.ctType === 1') 常规赛
                   font(v-if='scope.row.ctType === 2') 月度赛
                   font(v-if='scope.row.ctType === 3') 季度赛
                   font(v-if='scope.row.ctType === 4') 年度总决赛
                   font(v-if='scope.row.ctType === 5') 挑战赛
                   font(v-if='scope.row.ctType === 6') 群英赛
            el-table-column(prop='projectType',header-align='center',align='center',label='比赛项目')
               template(slot-scope="scope")
                   el-tag(v-if='scope.row.projectType === 1') 单打
                   el-tag(v-if='scope.row.projectType === 2') 双打
            el-table-column(prop='level',header-align='center',align='center',label='比赛级别')
            el-table-column(prop='rank',header-align='center',align='center',label='总名次')
            el-table-column(prop='score',header-align='center',align='center',label='获得积分')
            el-table-column(prop='remark',header-align='center',align='center',label='积分奖惩说明')
            el-table-column(prop="matchStatus" header-align="center" align="center" label="比赛状态" width="100")
              template(slot-scope="scope")
                font(v-if="scope.row.matchStatus === 1")
                  span.danger()
                  span() &nbsp; 未审核
                font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime() > new Date().getTime()")
                  span.success()
                  span() &nbsp; 已发布
                font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime() <= new Date().getTime() && new Date().getTime() <= new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount < scope.row.applySize")
                  span.warning()
                  span() &nbsp; 报名中
                font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime() <= new Date().getTime() && new Date().getTime() <= new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount >= scope.row.applySize && scope.row.bench == 1")
                  span.warning()
                  span() &nbsp; 报满可替
                font(v-if="scope.row.matchStatus === 2 && new Date(scope.row.matchSignStartTime).getTime() <= new Date().getTime() && new Date().getTime() <= new Date(scope.row.matchSignEndTime).getTime() && scope.row.joinCount >= scope.row.applySize && scope.row.bench == 0")
                  span.warning()
                  span() &nbsp; 已报满
                font(v-if="scope.row.matchStatus === 2 && new Date().getTime() > new Date(scope.row.matchSignEndTime).getTime() && new Date().getTime() < new Date(scope.row.matchStartTime).getTime()")
                  span.warning()
                  span() &nbsp; 报名结束
                font(v-if="scope.row.matchStatus === 2 && new Date().getTime() > new Date(scope.row.matchStartTime).getTime()")
                  span.warning()
                  span() &nbsp; 已开赛
                font(v-if="scope.row.matchStatus === 3")
                  span.warning()
                  span() &nbsp; 已取消
                font(v-if="scope.row.matchStatus === 4")
                  span.warning()
                  span() &nbsp; 已结束
                font(v-if="scope.row.matchStatus === 5")
                  span.warning()
                  span() &nbsp; 已拒绝
            el-table-column(prop='',header-align='center',align='center',label='操作')
                    template(slot-scope="scope")
                      el-menu.menuPonit(:collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="viewHandle(scope.row.matchId)") 查看基本信息
                                el-menu-item(index="1-2" @click="sorceDeduct(scope.row.scoreId,scope.row.id)" v-show="scope.row.scoreStatus==0") 积分扣除
                                el-menu-item(index="1-3" @click="sorceRemove(scope.row.scoreId,scope.row.id)" v-show="scope.row.scoreStatus==1" ) 取消扣除
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        el-dialog(title="积分扣除" :visible.sync="deductVisible" :modal-append-to-body='false')
          el-form(:model="deductForm", :rules="deductRules", ref="deductForm")
            el-form-item(label="请填写理由：" prop="remark")
              el-input(type="textarea" v-model="deductForm.remark")
            el-button(type="primary" @click="deductSubmit()") 确认
            el-button(@click="deductVisible=false") 取消
</template>

<script>
export default {
  data () {
    return {
      isCollapse: true,
      dataForm: {
        ctType: '',
        projectType: '',
        level: '',
        ctStrTime: '',
        ctEndTime: ''
      },
      deductForm: {
        remark: ''
      },
      scoreId: '',
      score: '',
      mbForm: {
        name: '',
        mobile: '',
        idCard: '',
        gender: '',
        gameNum: '',
        scoreNum: '',
        yearScore: '',
        quarterScore: ''
      },
      deductRules: {
        remark: [
          { required: true, message: '请填写理由!', trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur'
          }
        ]
      },
      mbId: '',
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      deductVisible: false,
      matchInfoId: null
    }
  },
  mounted: function () {},
  created () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      this.mbId = this.$route.query.mbId
      console.log(this.mbId)
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/ctCompetition/gameList'),
        method: 'post',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          ctType: this.dataForm.ctType,
          projectType: this.dataForm.projectType,
          level: this.dataForm.level,
          ctStrTime: this.dataForm.ctStrTime,
          ctEndTime: this.dataForm.ctEndTime,
          mbId: this.mbId
        }
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.rows
          this.totalPage = data.page.total
          this.mbForm.name = data.mbMember.name
          this.mbForm.mobile = data.mbMember.mobile
          this.mbForm.idCard = data.mbMember.idCard
          if (data.mbMember.gender == 0) {
            this.mbForm.gender = '男'
          } else {
            this.mbForm.gender = '女'
          }
          this.mbForm.gameNum = data.mbMember.gameNum
          this.mbForm.scoreNum = data.mbMember.scoreNum
          this.mbForm.yearScore = data.mbMember.yearScore
          this.mbForm.quarterScore = data.mbMember.quarterScore
          this.mbForm.id = data.mbMember.id
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    viewHandle (matchId) {
      this.$router.push({
        path: '../ct/competition/level',
        query: { matchId: matchId }
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    sorceDeduct (scoreId, id) {
      this.deductVisible = true
      this.scoreId = scoreId
      this.matchInfoId = id
    },
    sorceRemove (scoreId, id) {
      this.scoreId = scoreId
      this.matchInfoId = id
      this.$confirm(`是否取消扣除该场比赛积分?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/ctScore/update`),
          method: 'post',
          data: {
            id: this.scoreId,
            remark: '',
            status: 0,
            matchInfoId: this.matchInfoId,
            mbMemberId: this.mbForm.id
          }
        }).then(data => {
          if (data && data.code === 0) {
            this.$message({
              message: '该场比赛积分未扣除！',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          }
        })
      })
    },
    deductSubmit () {
      this.$refs['deductForm'].validate(valid => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/ctScore/update`),
            method: 'post',
            data: {
              id: this.scoreId,
              remark: this.deductForm.remark,
              // score: this.score,
              matchInfoId: this.matchInfoId,
              mbMemberId: this.mbForm.id,
              status: 1
            }
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: '该场比赛积分已扣除！',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.deductVisible = false
                  this.getDataList()
                }
              })
            }
          })
        }
      })
    }
  }
}
</script>
<style >
.mb-game-userInfo {
  display: flex;
  justify-content: flex-start;
}
.mb-game-userInfo > .el-form-item:nth-child(1) {
  margin-left: 0px;
}
.mb-game-userInfo > .el-form-item {
  margin-left: 30px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
